<template>
  <v-container class="page-content px-5" style="  width: 100%">
    <v-toolbar
        class="removeBtnPaddingRight"
        color="#DADADA"
        dense
        flat
    >
      <v-text-field
          class="pb-1"
          single-line
          v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
      </v-text-field>
      <v-select
          v-model="pagination.filters.order_type"
          label="Тип пропуска"
          class="pt-5 px-1"
          style="padding-bottom: 2px"
          single-line
          flat
          :items="choices.order_type"
      >
      </v-select>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="isLoading"
        multi-sort
        :page.sync="pagination.page"
        :items-per-page.sync="pagination.size"
        :server-items-length="count"
        :options.sync="options"
        :footer-props="{'items-per-page-options':[10,50,100]}"
        class="elevation-1"
    >
      <template v-slot:item.through_number="props">
        <span v-if="props.item.through_number === null" style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">Отсутствует</span>
        <span v-else style="text-decoration: underline; color: #065aad; cursor: pointer" @click="getDetail(props.item)">{{props.item.through_number}}</span>
      </template>
      <template v-slot:item.responsible="{ item }">
        <span>{{ item.responsible.fio }}</span>
      </template>
      <template v-slot:item.status="{ item }">
        <span>{{ order_status(item) }}
          <v-tooltip bottom  v-if="item.automate_annul">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
                small
                class="pb-1 medium-primary"
                v-bind="attrs"
                v-on="on"
            >
              hdr_auto
            </v-icon>
          </template>
          <span>Аннулирована автоматически</span>
          </v-tooltip>
        </span>
      </template>
      <template v-slot:item.last_update="{ item }">
        <span>{{ displayDate(item.last_update, true) }}</span>
      </template>
      <template v-slot:item.start_date="{ item }">
        <span>{{ displayDate(item.start_date) }}</span>
      </template>
      <template v-slot:item.end_date="{ item }">
        <span>{{ displayDate(item.end_date) }}</span>
      </template>
      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="loadData()"
        >
          Обновить
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import names from "@/modules/responsible/routers/names";
import {displayDate} from "@/helper";

export default {
  name: "ResponsibleOrdersList",
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список заявок",
      search: {
        parameter: "search"
      },
      pagination: {
        filters: {
          "order_type": null,
          "order_status": null
        }
      },
      choices: {
        order_type: []
      },
      headers: [
        {text: "Номер", value: "through_number", sortable: true, align: "start" , width: "10%"},
        {text: "Тип пропуска", value: "order_type", sortable: false, align: "start" , width: "10%"},
        {text: "Ответственный", value: "responsible", sortable: true, align: "start", width: "20%"},
        {text: "Дата начала", value: "start_date", sortable: true, align: "center", width: "15%"},
        {text: "Дата окончания", value: "end_date", sortable: true, align: "center", width: "15%"},
        {text: "Статус", value: "status", sortable: false, align: "center", width: "15%"},
        {text: "Изменение статуса", value: "last_update", sortable: true, align: "center", width: "15%"}
      ]
    }
  },
  watch: {
  },
  computed:{
    ...mapGetters({
      items: "responsible/getOrdersList",
      count: "responsible/getOrdersCount",
      isLoading: "responsible/isLoadingOrders"
    })
  },
  methods: {
    ...mapActions({
      loadOrdersList: "responsible/loadOrdersList",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices"
    }),
    displayDate: displayDate,
    getDetail(item) {
      this.$router.push({name: names.ORDERS.DETAIL, params: {idOrders: item.id}}).catch(() => {})
    },
    loadData(url=undefined){
      this.loadOrdersList({
        url: url,
        urlAppend: (url) => {
          return this.addSizeParameter(url);
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
      this.loadChoices()
    },
    order_status (item) {
      if (item.is_formalized && item.is_agreed === null && !item.automate_annul) {
        return "Оформлена"
      } else if (item.is_withdrawn) {
        return "Отозвана"
      } else if (item.is_agreed && item.is_formalized && !item.is_annul) {
        return "Согласована"
      } else if (item.is_agreed === false && item.is_formalized) {
        return "Отклонена"
      } else if (item.is_agreed === true && item.is_annul || item.automate_annul) {
        return "Аннулирована"
      } else {
        return "Создана"
      }
    },
    checkEditFlag(item) {
      if (item.is_agreed) return {icon: "highlight_off", text: "Отозвать заявку", form: "Вы уверены, что хотите отозвать данную заявку ?"}
      else if (item.is_agreed === null && item.is_formalized) return {icon: "undo", text: "Расформировать заявку", form: "Вы уверены, что хотите расформировать данную заявку ?"}
      else return {icon: "redo", text: "Сформировать заявку", form: "Вы уверены, что хотите сформировать данную заявку и отправить ее на соглосование?"}
    },
    loadChoices() {
      this.loadOrderTypeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_type = val
          this.choices.order_type.push({value: "", text: "Все"})
        }
      })
    }
  },
  created() {
    this.loadData()
  }

}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
